export default {
      id: "Icon--lockOpen-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--lockOpen",
      toString: function () {
        return this.url;
      }
    }